// rxjs-extension/reactives/optimisticObservable.ts
import { firstValueFrom, Observable } from "rxjs";
import { map, skipWhile, startWith, takeWhile } from "rxjs/operators";
function toOptimistic(obs, initialValue) {
  return new OptimisticObservable(obs.pipe(map((val) => ({ data: val, fullyLoaded: true }))), {
    data: initialValue,
    fullyLoaded: false
  });
}
var OptimisticObservable = class extends Observable {
  constructor(rawDataFeed, optimisticValue) {
    super((subscriber) => {
      this.dataFeed.subscribe({
        next: ({ data }) => subscriber.next(data),
        error: (e) => subscriber.error(e),
        complete: () => subscriber.complete()
      });
    });
    this.rawDataFeed = rawDataFeed;
    this.optimisticValue = optimisticValue;
  }
  get dataFeed() {
    return this.rawDataFeed.pipe(startWith(this.optimisticValue));
  }
  get isReady() {
    return this.dataFeed.pipe(map((d) => d.fullyLoaded));
  }
  get isLoading() {
    return this.isReady.pipe(map((x) => !x));
  }
  get completeWhenDone() {
    return this.dataFeed.pipe(
      takeWhile((d) => !d.fullyLoaded),
      map((d) => d.data)
    );
  }
  get whenReady() {
    return this.dataFeed.pipe(
      skipWhile((dfe) => !dfe.fullyLoaded),
      map((d) => d.data)
    );
  }
  get result() {
    return firstValueFrom(this.whenReady);
  }
  breakReactivity() {
    if (!this.optimisticValue.fullyLoaded)
      throw new Error("not ready yet. Please use subscriptions generally if you can");
    return this.optimisticValue.data;
  }
};
export {
  OptimisticObservable,
  toOptimistic
};
